import React from "react";
import "../assets/css/TermsUsage.css"
const TermsUsage = () => {
  return (
    <div className="terms-container">
      {/* Banner */}
      <div className="bannerTerms">
        <h1>Terms & Conditions</h1>
      </div>

      {/* Content */}
      <div className="contentTerms">
        <p>
          This document is an electronic record in terms of the Information Technology Act, 2000
          and rules thereunder as applicable, and the amended provisions pertaining to electronic
          records in various statutes as amended by the Information Technology Act, 2000. This
          electronic record is generated by a computer system and does not require any physical or
          digital signatures.
        </p>

        <p>
          This document is published in accordance with the provisions of Rule 3 (1) of the
          Information Technology (Intermediaries Guidelines) Rules, 2011, requiring publishing the
          rules and regulations, privacy policy, and Terms of Use for access or usage of the domain
          name &nbsp;<a href="https://mento.in/" target="_blank" rel="noopener noreferrer">Mento.in</a>.
        </p>

        <h2>Ownership</h2>
        <p>
          The Platform is owned by Roma Solanki, a company incorporated under the Companies Act, 1956,
          with its registered office at Khargone, Khargone, India (hereinafter referred to as
          “Platform Owner,” “we,” “us,” “our”).
        </p>

        <h2>Usage of Platform</h2>
        <p>
          Your use of the Platform and its services and tools are governed by these Terms of Use,
          including applicable policies incorporated herein by reference. By merely using the Platform,
          you contract with the Platform Owner, and these Terms of Use constitute your binding obligations.
        </p>

        <h2>Medical Disclaimer</h2>
        <p>
          Mento does not deal with medical or psychological emergencies. We are not designed to offer
          support in crisis situations – including when an individual is experiencing thoughts of self-harm
          or suicide, or is showing symptoms of severe clinical disorders such as schizophrenia and other
          psychotic conditions.
        </p>
        <p>
          If you feel you are experiencing any of these difficulties, we urge you to seek help at the
          nearest hospital or emergency room where you can connect with a psychiatrist, social worker,
          counselor, or therapist in person. You can also reach out to a suicide hotline in your country:&nbsp;
          <a href="http://www.healthcollective.in/contact/helplines" target="_blank" rel="noopener noreferrer">
           Healthcollective.in/contact/helplines
          </a>.
        </p>

        <h2>Privacy Policy</h2>
        <p>
          This Privacy Policy describes how Roma Solanki and its affiliates (“Roma Solanki,” “we,”
          “our,” “us”) collect, use, share, and protect your personal data through our website.&nbsp;
          <a href="https://mento.in/" target="_blank" rel="noopener noreferrer">Mento.in</a>.
        </p>
      </div>
    </div>
  );
};

export default TermsUsage;
